angular.module('filters')
    .filter('filterCurrencies', () => (currencies, query) => {

        if (angular.isUndefined(query) || !query) {

            return currencies;

        }
        return _.filter(currencies, (currency) => {

            if (!currency) {

                return false;

            }
            return (currency.toLowerCase().indexOf(query.toLowerCase()) === 0);

        });

    });



// WEBPACK FOOTER //
// ./scripts/filters/filterCurrencies.js